/**
 * @file 面包屑/路径等栈的实用类
 * @description 后续考虑调整所在目录
 */

import { ref, Ref } from '@vue/composition-api';
type PrimaryKey = string | null;
class Crumbs<T> {
  private crumbs: Ref<T[]> = ref([]);
  private pushHook: (value: T) => T = (value: T) => value;
  private primaryKey: PrimaryKey;

  /**
   * 面包屑/路径等栈的实用类
   * @param primaryKey 主键，用于标识元素，为空或 null 则使用元素本身匹配
   * @param pushHook 入栈前的钩子函数，入参同 push 方法，返回值将被入栈
   */
  constructor(primaryKey: PrimaryKey = null, pushHook?: (value: T) => T) {
    this.primaryKey = primaryKey;
    pushHook && (this.pushHook = pushHook);
  }
  public get value(): T[] {
    return this.crumbs.value;
  }
  public get last(): T | undefined {
    if (this.crumbs.value.length) {
      return this.crumbs.value[this.crumbs.value.length - 1];
    }
    return undefined;
  }
  public push(crumb: T): Ref<T[]> {
    this.crumbs.value.push(this.pushHook(crumb));
    return this.crumbs;
  }
  public pop(): Ref<T[]> {
    this.crumbs.value.pop();
    return this.crumbs;
  }
  public backTo(targetCrumb: T): Ref<T[]> {
    const index = this.crumbs.value.findIndex(crumb => {
      if (!this.primaryKey) {
        return crumb === targetCrumb;
      }
      // @ts-ignore
      return crumb[this.primaryKey] === targetCrumb[this.primaryKey];
    });
    this.crumbs.value.splice(index + 1);
    return this.crumbs;
  }
  /**
   * 清除面包屑，无入参时全部清除
   * @param clearPosition 代表清除clearPosition位置之后的crumbs
   */
  public clear(clearPosition?: number): Ref<T[]> {
    // 用typeof判断，避免clearPosition为0
    if (typeof clearPosition === 'number') {
      this.crumbs.value.splice(clearPosition);
    } else {
      this.crumbs.value = [];
    }
    return this.crumbs;
  }
}
export default Crumbs;
